import { render, staticRenderFns } from "./OrderDetailModal.vue?vue&type=template&id=31ed5480&scoped=true&"
import script from "./OrderDetailModal.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailModal.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailModal.vue?vue&type=style&index=0&id=31ed5480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed5480",
  null
  
)

export default component.exports